import { FeedbackPageForm, Header, Paragraph, ResultsPage, WelcomePageForm } from "@datagame/ui";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import { useState } from "react";

import { Game } from "../../../../../../../gql/graphql";
import { isQuickPickGame } from "../../../../../../../graphql/helpers/isQuickPickGame";

import styles from "./Content.module.scss";
import { isCardBasedGame } from "../../../../../../../graphql/helpers/CardBasedGame";

const cx = classNames.bind(styles);

export interface ContentProps {
  game: Game;
}

const STEPS = {
  welcomePage: "Welcome Page",
  gameResults: "Game Results",
  feedbackPage: "Feedback Page",
};

export interface StepProps {
  step: string;
  activeStep: string;
  onClick: (value: string) => void;
}

export const Step = ({ step, activeStep, onClick }: StepProps) => {
  return (
    <div
      className={cx("tab", { active: activeStep === step })}
      onClick={() => onClick(step)}
      onKeyDown={() => onClick(step)}
      role="button"
      tabIndex={0}
    >
      <Paragraph size="small" color="secondary" className={styles.stepText}>
        {step}
      </Paragraph>
    </div>
  );
};

export const Content = ({ game }: ContentProps) => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState("");

  return (
    <>
      <Header variant="h3">{t("project:preview.title")}</Header>
      <div className={styles.tabs}>
        {game.configuration.showWelcomePage && (
          <Step step={STEPS.welcomePage} activeStep={activeStep} onClick={setActiveStep} />
        )}
        {isCardBasedGame(game) && game.configuration.showGameResults && (
          <Step step={STEPS.gameResults} activeStep={activeStep} onClick={setActiveStep} />
        )}
        {game.configuration.showFeedbackPage && (
          <Step step={STEPS.feedbackPage} activeStep={activeStep} onClick={setActiveStep} />
        )}
      </div>

      {activeStep === STEPS.welcomePage && game.configuration.showWelcomePage && (
        <div className={styles.welcomePageWrapper}>
          <WelcomePageForm
            config={game.configuration.welcomePage}
            gameKind={game.kind}
            isQuickPickGame={isQuickPickGame(game)}
            theme={game.configuration.gameVisuals.themeColor}
          />
        </div>
      )}

      {activeStep === STEPS.feedbackPage &&
        "feedbackPage" in game.configuration &&
        game.configuration.showFeedbackPage && (
          <FeedbackPageForm
            config={game.configuration.feedbackPage}
            theme={game.configuration.gameVisuals.themeColor}
            className={styles.feedbackPage}
          />
        )}

      {activeStep === STEPS.gameResults && isCardBasedGame(game) && game.configuration.showGameResults && (
        <ResultsPage
          config={game.configuration.gameResults}
          result={50}
          cardClassName={styles.resultCard}
          themeColor={game.configuration.gameVisuals.themeColor}
        />
      )}

      {activeStep === "" && <Paragraph>{t("project:preview.selectTab")}</Paragraph>}
    </>
  );
};
